<template>
<span>
  {{ latestStatus }}  
</span>  
</template>
<script>
import { sortBy, first } from 'lodash'

export default {
  props: {
    statuses: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    getLatestStatus() {
      return first(
        sortBy(this.statuses, 'id').reverse()
      )
    }
  },

  computed: {
    latestStatus() {
      return this.statuses.length > 0 ? this.getLatestStatus().value : 'Unknown'
    }
  }
}
</script>